import React, { useMemo, useState, useEffect, useContext } from 'react'

import Axios from '../../axios-proas'
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsv3';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale'; 

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useNavigate, useLocation , useParams} from 'react-router-dom';
import { convertFileToBase64,getNotyfObject, getArbreJson, flattenData, checkValidity, renameSousNiveau, renameArrayProperties, addTestPropertyRecursive } from '../../shared/utility';
import Spinner from 'react-bootstrap/Spinner'
import { CTooltip } from '../../components/UI/CTooltip/CTooltip';
import {  CFBody, CFContainer, CFFormGroup, CFFormSection, CFFormWrapper, CFHeader, CFHeaderActions, CFHeaderTitle, CFHeaderWrapper, CFSection, DPContainer, ToggleIcon, ToggleLabel, CFHierarchieSection } from './CampaignForm.styled';
import { PrimaryBtnOutlineAction, SecondaryBtnOutlineAction, CancelBtnOutlineAction, FormInput, FormLabel } from '../../styles/Common';
import { FilterContainer, InputFilter, Option, TD, SelectFilter } from '../../styles/Table.styled';
import { useTranslation } from 'react-i18next';
import NavTabs from '../../components/UI/NavTabs/NavTabs';
import MandatoryMarker from '../../components/UI/MandatoryMarker';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import InfoHierarchie from '../../components/Entity/InfosLevel/InfosLevel'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { AbilityContext } from '../../ability/AbilityContext';
import { createContextualCan } from '@casl/react'
import InfoStepsCampagneAtestation from '../../components/Entity/InfoSteps/InfoStepsCampagneAtestation'  
import InfoStepsCamapgneEnquete from '../../components/Entity/InfoSteps/InfoStepsCamapgneEnquete'

import { EntInfosContainer, IconDiv, EICol, EntHeaderTitle, FormInputAgence } from '../../components/Entity/Infos/Infos.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { useTheme } from 'styled-components';
import CodesExternesModal from '../../components/Campaigns/CodesExternesModal/CodesExternesModal'
const Can = createContextualCan(AbilityContext.Consumer);
function CampaignForm({  setHierarchieAndNiveaux, hierarchicalParent, niveauxParent, rootPath, userType }) {  
    const [niveau, setNiveau] = useState([])
    const [hierarchical, setHierarchical] = useState([]); 
    let {uid } = useParams(); 
    let notyf = getNotyfObject();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const currentDate = new Date();
    const [selectedStartDate, setSelectedStartDate] = React.useState(currentDate);
    const [startDateError, setStartDateError] = useState(false);
    const [selectedEndDate, setSelectedEndDate] = React.useState(new Date(new Date().setFullYear(new Date().getFullYear() , 12, 0 )));
    const [endDateError, setEndDateError] = useState(false);
    const [selectedEntities, setSelectedEntities] = useState([]);
    const [campaignData, setCampaignData] = useState([]);
    const [campaignErrors, setCampaignErrors] = useState([]);
    const [createCampaignLoading, setCreateCampaignLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("parametres");
    const [steps, setSteps] = useState([])
    const theme = useTheme()
    const colorToggleOnIcon = theme.colors.lightBlack;
    const tabsList = useMemo(() => [
        {title: t("global:parametres", "Information"), value: "parametres"},  
    ], [t]);
    const location = useLocation();
    const { state } = location;
    const ability = useContext(AbilityContext);
    const [confirmationModalCodeExterneShow, setConfirmationModalCodeExterneShow] = useState(false);
    const refreshHierarchieClickHandler = () => {
        setNiveau(niveauxParent)
        setHierarchical(hierarchicalParent)
    }

    const getDefaultHierarchie = (entityUid) => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs/' + entityUid, {
            params: null,
        },).then((response) => {
              
            let hierarchieBailleur = response?.data?.metadata?.hierarchieBailleur
            const levelTemp = (hierarchieBailleur?.orderOfLevel != null && hierarchieBailleur?.orderOfLevel != "") ?hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } }):null
            let firsteLevel = hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } })[0]?.libelle
            let niveauxParentTemp=levelTemp ? levelTemp : []
            if (firsteLevel != null && levelTemp!=null ) {
                let temp = hierarchieBailleur.children
                let levelSpliceFirst = levelTemp.filter((item, index) => index > 0)
                let tempData = renameSousNiveau(temp, levelSpliceFirst)
                //console.log(tempData)
                let data = addTestPropertyRecursive(tempData, levelTemp, 0)
                //console.log(data)
                let hierarchicalParentTemp=flattenData(data, 0, levelTemp)

                setHierarchieAndNiveaux(hierarchicalParentTemp, niveauxParentTemp, response?.data?.libelleCourt)
            }

       
        }).catch(err => {
            notyf.error("Une erreur s'est produite!");
        })
    
    }
    const [codesInternes, setCodesInternes] = useState([])
    const [codesExternes, setCodesExternes] = useState([])
    const [isCodesExternes, setIsCodesExternes] = useState(false)
    useEffect(() => {
        let entityUid = localStorage.getItem('BailleurId');
        getDefaultHierarchie(entityUid)
        if (uid != null) {
            Axios.get("/api/campagnes/" + uid + "/codeexternes").then(res => {
                console.log(res?.data?.length > 0)
                setCodesExternes(res?.data);
                setIsCodesExternes(res?.data?.length > 0)
            }).catch(response => {
                notyf.error("Une erreur s'est produite")
            })
            Axios.get("/api/campagnes/codeinternes").then(res => {
                console.log(res?.data)
                setCodesInternes(res?.data)
            }).catch(response => {
                notyf.error("Une erreur s'est produite")
            })
            
        }
    }, [])

    useEffect(() => {
        if (uid != null) {   
            Axios.get("/api/campagnes/" + uid).then(response => {
                let hierarchieBailleur = response?.data?.hierarchieBailleur
                if (hierarchieBailleur) {
                    const levelTemp = (hierarchieBailleur?.orderOfLevel != null && hierarchieBailleur?.orderOfLevel != "") ? hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } }) : null
                    let firsteLevel = hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } })[0]?.libelle
                    setNiveau(levelTemp ? levelTemp : [])
                    if (firsteLevel != null && levelTemp != null) {
                        let temp = hierarchieBailleur.children
                        let levelSpliceFirst = levelTemp.filter((item, index) => index > 0)
                        let tempData = renameSousNiveau(temp, levelSpliceFirst)
                        let data = addTestPropertyRecursive(tempData, levelTemp, 0)
                        setHierarchical(flattenData(data, 0, levelTemp))
                    }
                }
                setCampaignData(response.data)
                setSteps(response?.data?.etapes?.children ? response?.data?.etapes?.children:[])
                setSelectedEntities(response.data.agences)
            }).catch(response => {
                notyf.error("Une erreur s'est produite")
            })
        } else {
            setNiveau(niveauxParent)
            setHierarchical(hierarchicalParent)
        }
    }, [niveauxParent])

    const formatEntities = (entities) => {
        return entities.split(',')
    }
   
    const tabClickHandler = (tab) => {
        setActiveTab(tab);
    }
   
    const handleOuvertureOpsDateChange = (date) => {
        if (ability.can('update', 'Campagne')) {
            if (date.toString() === "Invalid Date") {
                setStartDateError(true)
            } else
                if (date.getFullYear <= 1900 || date.getFullYear > 2100) {
                    setStartDateError(true)
                } else {
                    setStartDateError(false)
                }
            setSelectedStartDate(date);
            setCampaignData({
                ...campaignData,
                dateOuvertureOps: new Date(date.getTime()),
            })
        }
    };

    const handleFermetureOpsDateChange = (date) => {
        if (ability.can('update', 'Campagne')) {
            if (date.toString() === "Invalid Date") {
                setEndDateError(true)
            } else
                if (date < selectedStartDate || date.getFullYear > 2100) {
                    setEndDateError(true)
                } else {
                    setEndDateError(false)
                }
            setSelectedEndDate(date);
            setCampaignData({
                ...campaignData,
                dateFermetureOps: new Date(date.getTime()),
            })
        }
    };

    const handleOuvertureSlstDateChange = (date) => {
        if (ability.can('update', 'Campagne')) {
            if (date.toString() === "Invalid Date") {
                setStartDateError(true)
            } else
                if (date.getFullYear <= 1900 || date.getFullYear > 2100) {
                    setStartDateError(true)
                } else {
                    setStartDateError(false)
                }
            setSelectedStartDate(date);
            setCampaignData({
                ...campaignData,
                dateOuvertureSls: new Date(date.getTime()),
            })
        }
    };

    const handleFermetureSlsDateChange = (date) => {
        if (userType == "ADMIN_YOUNOV") {
            if (date.toString() === "Invalid Date") {
                setEndDateError(true)
            } else
                if (date < selectedStartDate || date.getFullYear > 2100) {
                    setEndDateError(true)
                } else {
                    setEndDateError(false)
                }
            setSelectedEndDate(date);
            setCampaignData({
                ...campaignData,
                dateFermetureSls: new Date(date.getTime()),
            })
        }
    };

    const generateMaxEndDate = () => {
        let startDate = new Date(selectedStartDate);
        return new Date( startDate.setFullYear(startDate.getFullYear() , 12, 0 ))
    }

    const optionChangeHandler = (name, value) => {
        if (ability.can('update', 'Campagne')) {
            if (name == "estRenvoiEnquete" && value == 0) {
                setCampaignData({
                    ...campaignData,
                    delaiBlocageRenvoiJour: null,
                    [name]: value
                })
            } else
            {
                setCampaignData({
                    ...campaignData,
                    [name]: value
                })
            }
            
        }
    }

 
    const titleChangeHandler = (e) => {
        if (ability.can('update', 'Campagne')) {
            const value = e.target.value
            const key = e.target.name
            setCampaignData({
                ...campaignData,
                [key]: value
            })
        }
    }

    const handleChange = (index) => {
        if (ability.can('update', 'Campagne')) {
            setCampaignData({
                ...campaignData,
                gestionRessources: index
            })
        }
    };

    const handleChangeColisage = (index) => {
        if (ability.can('update', 'Campagne')) {
            setCampaignData({
                ...campaignData,
                estColisage: index
            })
        }
    };

    const checkCampaignForm = () => {
        let errors = []
        if (!campaignData.hasOwnProperty('dateOuvertureSls'))
            errors.push("Date de début de campagne SLS invalide")  
        if (!campaignData.hasOwnProperty('dateFermetureSls'))
            errors.push("Date de fin de campagne SLS invalide")

        if (!campaignData.hasOwnProperty('dateOuvertureOps'))
            errors.push("Date de début de campagne OPS invalide")

        if (!campaignData.hasOwnProperty('dateFermetureOps') )
            errors.push("Date de fin de campagne OPS invalide")

        if (!campaignData.hasOwnProperty('libelle'))
            errors.push("Le champ Titre est vide ou non valide")
  
        if (!campaignData.hasOwnProperty('anneeReference') ||campaignData?.anneeReference?.length <1)
            errors.push("Le champ  Année Réference est vide ou non valide")
        return errors;
    }

    const createCampaign = () => {
        let temp = hierarchical
        let level = niveau
        let levelString = niveau?.map((item, index) => { return item.libelle }).join('/')
        let res = getArbreJson(temp, level, rootPath)
        let HierarchieBailleur = {
            OrderOfLevel: levelString, RootPath: rootPath, children: renameArrayProperties(res)
        };
        let etapesTraitement = { children: steps };
        let uidEntity = state?.uid

        const campaignDataToAdd = {
            ...campaignData,
            HierarchieBailleur,
            BailleurId: +uidEntity,
            anneeReference: +campaignData.anneeReference,
            delaiBlocageRenvoiJour: +campaignData?.delaiBlocageRenvoiJour || null,

            dateOuvertureOps: campaignData?.dateOuvertureOps ? format(new Date(campaignData.dateOuvertureOps), 'yyyy-MM-dd') : null,
            dateFermetureOps: campaignData?.dateFermetureOps ? format(new Date(campaignData.dateFermetureOps), 'yyyy-MM-dd') : null,
            dateOuvertureSls: campaignData.dateOuvertureSls ? format(new Date(campaignData.dateOuvertureSls), 'yyyy-MM-dd') : null,
            dateFermetureSls: campaignData.dateFermetureSls ? format(new Date(campaignData.dateFermetureSls), 'yyyy-MM-dd'):null,
                 
            estTeledeclaration: Boolean(campaignData.estTeledeclaration),
            estSaisieOutilExterne: Boolean(campaignData.estSaisieOutilExterne),
            estEconsentement: Boolean(campaignData.estEconsentement),
            estConsultable: Boolean(campaignData.estConsultable),
            estAttestationAssurance: Boolean(campaignData.estAttestationAssurance),
            assureurObligatoire: Boolean(campaignData.assureurObligatoire),
            estActive: Boolean(campaignData.estActive),
            estColisage: Boolean(campaignData.estColisage),
            estRepartitionRfr: Boolean(campaignData.estRepartitionRfr),
            estNumeroFiscal: Boolean(campaignData.estNumeroFiscal),

            estRenvoiEnquete: Boolean(campaignData.estRenvoiEnquete),

            estSmsCompletude: Boolean(campaignData.estSmsCompletude),
            estGestionBaisseDeRevenus: Boolean(campaignData.estGestionBaisseDeRevenus),
            estCalculBaisseDeRevenus: Boolean(campaignData.estCalculBaisseDeRevenus),
            estControleAIOccupantsMajeursNonAC: Boolean(campaignData.estControleAIOccupantsMajeursNonAC),

            etapes: etapesTraitement

        }
       
        Axios.post(import.meta.env.VITE_PREFIX_SERVER_API + 'campagnes', campaignDataToAdd).then(response => {
            notyf.success("La campagne a été créée avec succès")
            setCreateCampaignLoading(false);
            navigate(-1);
        }).catch(response => {
            notyf.error("Une erreur s'est produite")
            setCreateCampaignLoading(false)
        })
    }

    const createCampaignClickHandler = () => {
        let errors = checkCampaignForm()
        if(errors.length > 0)
            setCampaignErrors(errors)
        else{
            setCampaignErrors([]);
            createCampaign()
        }
    }
  
    const updateCampaign = () => {
        let temp = hierarchical
        let level = niveau
        let levelString = niveau.map((item, index) => { return item.libelle }).join('/')
        let res = getArbreJson(temp, level, rootPath)
        /* let children = JSON.stringify({ OrderOfLevel: levelString, RootPath: entity?.libelleCourt, [niveau[0]?.libelle]: res });*/
        let HierarchieBailleur = {
            OrderOfLevel: levelString, RootPath: rootPath, children: renameArrayProperties(res)
        };
        let etapesTraitement = { children: steps };

        const campaignDataToAdd = {
            ...campaignData,
            HierarchieBailleur,
           // BailleurId: +uidEntity,
            anneeReference: +campaignData.anneeReference,
            dateOuvertureOps: campaignData?.dateOuvertureOps ? format(new Date(campaignData.dateOuvertureOps), 'yyyy-MM-dd') : null,
            dateFermetureOps: campaignData?.dateFermetureOps ? format(new Date(campaignData.dateFermetureOps), 'yyyy-MM-dd') : null,
            dateOuvertureSls: campaignData.dateOuvertureSls ? format(new Date(campaignData.dateOuvertureSls), 'yyyy-MM-dd') : null,
            dateFermetureSls: campaignData.dateFermetureSls ? format(new Date(campaignData.dateFermetureSls), 'yyyy-MM-dd') : null,
            delaiBlocageRenvoiJour: +campaignData?.delaiBlocageRenvoiJour||null,

            estTeledeclaration: Boolean(campaignData.estTeledeclaration),
            estSaisieOutilExterne: Boolean(campaignData.estSaisieOutilExterne),
            estEconsentement: Boolean(campaignData.estEconsentement),
            estConsultable: Boolean(campaignData.estConsultable),
            estAttestationAssurance: Boolean(campaignData.estAttestationAssurance),
            assureurObligatoire: Boolean(campaignData.assureurObligatoire),
            estActive: Boolean(campaignData.estActive),
            estColisage: Boolean(campaignData.estColisage),
            estRepartitionRfr: Boolean(campaignData.estRepartitionRfr),
            estSmsCompletude: Boolean(campaignData.estSmsCompletude),
            estNumeroFiscal: Boolean(campaignData.estNumeroFiscal),

            estRenvoiEnquete: Boolean(campaignData.estRenvoiEnquete),


            estGestionBaisseDeRevenus: Boolean(campaignData.estGestionBaisseDeRevenus),
            estCalculBaisseDeRevenus: Boolean(campaignData.estCalculBaisseDeRevenus),
            estControleAIOccupantsMajeursNonAC: Boolean(campaignData.estControleAIOccupantsMajeursNonAC),
            etapes: etapesTraitement

        }

        Axios.put(import.meta.env.VITE_PREFIX_SERVER_API + 'campagnes', campaignDataToAdd).then(response => {
            notyf.success("La campagne a été modifiée avec succès")
            setCreateCampaignLoading(false);
            navigate(-1);
        }).catch(response => {
            notyf.error("Une erreur s'est produite")
            setCreateCampaignLoading(false)
        })
    }

    const updateCampaignClickHandler = () => {
        let errors = checkCampaignForm()
        if (errors.length > 0)
            setCampaignErrors(errors)
        else {
            setCampaignErrors([]);
            updateCampaign()
        }
    }
           
    return (
        <>
            {
                userType == "BAILLEUR" && (
                    <div className="alert alert-warning mt-2" role="alert">
                        <ul>
                            Ces informations sont fournies à titre consultatif uniquement. Elles ne peuvent pas être modifiées. Si vous visualisez une information erronée, prenez contact avec votre gestionnaire Younov
                        </ul>
                    </div>
                )
            }
            <CFContainer>
                <CFHeaderWrapper>
                    <CFHeader>
                        {campaignData?.id ?
                            (
                                <CFHeaderTitle  >
                                   {campaignData?.libelle} {campaignData?.anneeReference}
                                   
                                </CFHeaderTitle>

                            ): (
                                <CFHeaderTitle >
                                    Nouvelle campagne
                                </CFHeaderTitle>

                                )
                            }
                        {/*<CFHeaderTitle >{campaignData?.id ? "Titre : "+campaignData.libelle + "  " + campaignData.anneeReference : "Nouvelle campagne"}*/}
              
                        {/*</CFHeaderTitle>*/}
                        <CFHeaderActions>
                            { !uid ?(
                                createCampaignLoading ? (
                                        <Spinner animation="border" variant="primary" />
                                ) 
                                : 
                                    <PrimaryBtnOutlineAction
                                        style={{ backgroundColor: theme.colors.success }}
                                        bd={theme.colors.green}
                                        onClick={() => createCampaignClickHandler()}
                                    >
                                        <span>Valider</span> 
                                    </PrimaryBtnOutlineAction>)
                              :
                                ability.can('update', 'Campagne') &&
                                <PrimaryBtnOutlineAction
                                    style={{ backgroundColor: theme.colors.success }}
                                    bd={theme.colors.green}
                                    onClick={() => updateCampaignClickHandler()}//update
                                >
                                    <span>Valider</span>
                                </PrimaryBtnOutlineAction>
                            }
                            <CancelBtnOutlineAction
                                color={theme.colors.danger}
                                border={theme.colors.danger}
                                onClick={() => navigate(-1)}
                            >
                                <span>Annuler</span> 
                            </CancelBtnOutlineAction>

                               
                        </CFHeaderActions>
                    </CFHeader>
                    {/*<NavTabs*/}
                    {/*    tabsList={tabsList}*/}
                    {/*    activeTab={activeTab}*/}
                    {/*    onTabClick={tabClickHandler}*/}
                    {/*/>*/}
                </CFHeaderWrapper>

                <CFBody>
                    {
                        campaignErrors && campaignErrors.length > 0 ? (
                            <div className="alert alert-danger mt-2 campaignForm__errors_container" role="alert">
                                <ul>
                                    {
                                        campaignErrors.map(error => (<li key={error}>{error}</li>))
                                    }
                                </ul>
                            </div>
                        ) : null
                    }
                    <CFSection>
                    
                        <CFFormWrapper>
                            <CFFormSection style={{ height: userType == "ADMIN_YOUNOV" ? "645px":"600px" }}>
                                <CFFormGroup>
                                    <FormLabel htmlFor="title" >Bailleur</FormLabel>
                                    <FormInput
                                        id="title"
                                        type="text"
                                        placeHolder=" "
                                        value={state?.raisonSociale || ""}
                                        //onChange={e => titleChangeHandler(e)}
                                        maxLength={255}
                                        name="libelle"
                                    />
                                </CFFormGroup>

                             

                                <CFFormGroup>
                                    <FormLabel htmlFor="title" >Titre <MandatoryMarker /></FormLabel>
                                    <FormInput
                                        id="title"
                                        type="text"
                                        placeHolder="Ex: Enquêtes OPS SLS "
                                        value={campaignData?.libelle || ""}
                                        onChange={e => titleChangeHandler(e)}
                                        maxLength={255}
                                        name="libelle"
                                    />
                                </CFFormGroup>
                                <CFFormGroup>
                                    <FormLabel htmlFor="anneeReference" >Année de référence<MandatoryMarker /></FormLabel>
                                    <FormInput
                                        id="anneeReference"
                                        type="number"
                                        placeHolder="Ex: 2025"
                                        value={campaignData?.anneeReference || ""}
                                        onChange={e => titleChangeHandler(e)}
                                        maxLength={255}
                                        name="anneeReference"
                                    />
                                </CFFormGroup>                            
                                <CFFormGroup>
                                    <FormLabel >OPS Période de validité <MandatoryMarker /></FormLabel>
                                </CFFormGroup>
                                <CFFormGroup>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                        <DPContainer style={{ width:"49%" }}>
                                            <DatePicker
                                                id="date-picker-dialog"
                                                label="Date ouverture OPS"
                                                format="dd/MM/yyyy"
                                               // minDate={currentDate}
                                                value={new Date(campaignData?.dateOuvertureOps)} 
                                                readOnly={!ability.can('update', 'Campagne')}
                                                onChange={handleOuvertureOpsDateChange}  
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage="Format de date invalide"
                                                maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                                minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                                renderInput={(params) => <TextField {...params} />}
                                                // open={true} control open dialog state
                                            />
                                        </DPContainer>
                                        <DPContainer style={{ width: "49%" }} >
                                            <DatePicker
                                                id="date-picker-dialog"
                                                label="Date Fermeture OPS"
                                                format="dd/MM/yyyy"
                                                readOnly={!ability.can('update', 'Campagne')}
                                                value={new Date(campaignData?.dateFermetureOps)} 
                                                onChange={handleFermetureOpsDateChange}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                //minDate={selectedStartDate}
                                                //maxDate={generateMaxEndDate()}
                                                invalidDateMessage="Format de date invalide"
                                                maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                                minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </DPContainer>
                                    </LocalizationProvider>
                                </CFFormGroup>
                                <CFFormGroup>
                                    <FormLabel >SLS Période de validité <MandatoryMarker /></FormLabel>
                                </CFFormGroup>
                                <CFFormGroup>
                                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                        <DPContainer style={{ width: "49%" }} >
                                            <DatePicker
                                                id="date-picker-dialog"
                                                label="Date ouverture SLS"
                                                format="dd/MM/yyyy"
                                                readOnly={!ability.can('update', 'Campagne')}
                                                //minDate={currentDate}
                                                value={new Date(campaignData?.dateOuvertureSls)} 

                                                onChange={handleOuvertureSlstDateChange}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                invalidDateMessage="Format de date invalide"
                                                maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                                minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                                renderInput={(params) => <TextField {...params} />}
                                            // open={true} control open dialog state
                                            />
                                        </DPContainer>
                                        <DPContainer style={{ width: "49%" }} >
                                            <DatePicker
                                                id="date-picker-dialog"
                                                label="Date Fermeture SLS"
                                                format="dd/MM/yyyy"
                                                readOnly={!ability.can('update', 'Campagne')}
                                                value={ new Date(campaignData?.dateFermetureSls) } 
                                                onChange={handleFermetureSlsDateChange} 
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                //minDate={selectedStartDate}
                                                //maxDate={generateMaxEndDate()}
                                                invalidDateMessage="Format de date invalide"
                                                maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                                minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </DPContainer>
                                    </LocalizationProvider>
                                </CFFormGroup>   
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Gestion Ressources </ToggleLabel>
                                    <ToggleIcon >
                                        <input
                                            type="checkbox"
                                            id="option1"
                                            checked={+campaignData?.gestionRessources === 1}
                                            onChange={() => handleChange(1)}
                                        />
                                        <label htmlFor="option1">&nbsp;&nbsp;Typologie</label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <input
                                            type="checkbox"
                                            id="option2"
                                            checked={+campaignData?.gestionRessources === 2}
                                            onChange={() => handleChange(2)}
                                        />
                                        <label htmlFor="option2">&nbsp;&nbsp;Montant</label>


                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel htmlFor="active"  active={false} >Active </ToggleLabel>
                                    <ToggleIcon active={+campaignData?.estActive}>
                                        {
                                            +campaignData?.estActive ?
                                                <ToggleOnIcon
                                                    name="active"
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estActive", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    name="active"
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estActive", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Consultable </ToggleLabel>
                                    <ToggleIcon active={uid ? +campaignData.estConsultable : +campaignData?.estConsultable}>
                                        {
                                            +campaignData?.estConsultable ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estConsultable", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estConsultable", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>

                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} > Télé-déclaration</ToggleLabel>
                                    <ToggleIcon active={campaignData.estTeledeclaration}>
                                        {
                                            campaignData?.estTeledeclaration ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estTeledeclaration", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estTeledeclaration", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                {userType == "ADMIN_YOUNOV" &&
                                    <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                        <ToggleLabel active={false} >Consentement </ToggleLabel>
                                        <ToggleIcon active={+campaignData?.estEconsentement}>
                                            {
                                                +campaignData?.estEconsentement ?
                                                    <ToggleOnIcon
                                                        style={{ color: theme.colors.secondary }}
                                                        fontSize="large"
                                                        onClick={() => optionChangeHandler("estEconsentement", 0)}
                                                    /> :
                                                    <ToggleOffIcon
                                                        style={{ color: theme.colors.younovGray }}
                                                        fontSize="large"
                                                        onClick={() => optionChangeHandler("estEconsentement", 1)}
                                                    />
                                            }
                                        </ToggleIcon>
                                    </CFFormGroup>
                                }
                               

                            </CFFormSection>

                         
                        </CFFormWrapper>
                        <CFFormWrapper>
                            <CFFormSection style={{ height: userType == "ADMIN_YOUNOV" ? "645px" : "600px" }}>
                             
                                                           
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Saisie Outil Externe</ToggleLabel>
                                    <ToggleIcon active={+campaignData?.estSaisieOutilExterne}>
                                        {
                                            +campaignData?.estSaisieOutilExterne ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estSaisieOutilExterne", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estSaisieOutilExterne", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>            
                              
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Numéro Fiscal  </ToggleLabel>
                                    <ToggleIcon active={uid ? +campaignData.estNumeroFiscal : +campaignData?.estNumeroFiscal}>
                                        {
                                            +campaignData?.estNumeroFiscal ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estNumeroFiscal", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estNumeroFiscal", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Répartition RFR </ToggleLabel>
                                    <ToggleIcon active={uid ? +campaignData.estRepartitionRfr : +campaignData?.estRepartitionRfr}>
                                        {
                                            +campaignData?.estRepartitionRfr ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estRepartitionRfr", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estRepartitionRfr", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Attestation Assurance </ToggleLabel>
                                    <ToggleIcon active={ +campaignData?.estAttestationAssurance}>
                                        {
                                            +campaignData?.estAttestationAssurance ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() =>  optionChangeHandler("estAttestationAssurance", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() =>  optionChangeHandler("estAttestationAssurance", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Assureur obligatoire </ToggleLabel>
                                    <ToggleIcon active={+campaignData?.assureurObligatoire}>
                                        {
                                            +campaignData?.assureurObligatoire ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("assureurObligatoire", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("assureurObligatoire", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Colisage </ToggleLabel>
                                    <ToggleIcon active={+campaignData?.estColisage}>
                                        {
                                            +campaignData?.estColisage ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estColisage", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estColisage", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Gestion baisse de revenus </ToggleLabel>
                                    <ToggleIcon active={+campaignData?.estGestionBaisseDeRevenus}>
                                        {
                                            +campaignData?.estGestionBaisseDeRevenus ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estGestionBaisseDeRevenus", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estGestionBaisseDeRevenus", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Calcul baisse de revenus </ToggleLabel>
                                    <ToggleIcon active={+campaignData?.estCalculBaisseDeRevenus}>
                                        {
                                            +campaignData?.estCalculBaisseDeRevenus ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estCalculBaisseDeRevenus", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estCalculBaisseDeRevenus", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <CTooltip title={"Contrôle des avis d’impôt des occupants majeurs non à charge"} className="tableActions__icon">
                                        <ToggleLabel active={false} >Contrôle AI occupants majeurs non à charge </ToggleLabel>
                                    </CTooltip> 
                                    <ToggleIcon active={+campaignData?.estControleAIOccupantsMajeursNonAC}>
                                        {
                                            +campaignData?.estControleAIOccupantsMajeursNonAC ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estControleAIOccupantsMajeursNonAC", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estControleAIOccupantsMajeursNonAC", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                     
                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >SMS de complétude </ToggleLabel>
                                    <ToggleIcon active={+campaignData?.estSmsCompletude}>
                                        {
                                            +campaignData?.estSmsCompletude ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estSmsCompletude", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estSmsCompletude", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                {uid &&
                                    <CFFormGroup>
                                        <ToggleLabel active={false} >Codes externes &nbsp;
                                            {isCodesExternes && userType == "ADMIN_YOUNOV" &&
                                                <CTooltip title={"Visualiser les codes externes"} className="tableActions__icon">
                                                <VisibilityIcon onClick={() => setConfirmationModalCodeExterneShow(true)} />
                                                </CTooltip> 
                                            }
                                        </ToggleLabel>
                                        
                                        <ToggleIcon >
                                            {
                                                isCodesExternes ?
                                                    <ToggleOnIcon
                                                        style={{ color: theme.colors.secondary }}
                                                        fontSize="large"

                                                    /> :
                                                    <ToggleOffIcon
                                                        style={{ color: theme.colors.younovGray }}
                                                        fontSize="large"

                                                    />
                                            }
                                            </ToggleIcon>
                                       
                                    </CFFormGroup>
                                }

                                <CFFormGroup style={{ marginBottom: "0.6rem" }}>
                                    <ToggleLabel active={false} >Renvoi enquête papier </ToggleLabel>
                                    <ToggleIcon active={+campaignData?.estRenvoiEnquete}>
                                        {
                                            +campaignData?.estRenvoiEnquete ?
                                                <ToggleOnIcon
                                                    style={{ color: theme.colors.secondary }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estRenvoiEnquete", 0)}
                                                /> :
                                                <ToggleOffIcon
                                                    style={{ color: theme.colors.younovGray }}
                                                    fontSize="large"
                                                    onClick={() => optionChangeHandler("estRenvoiEnquete", 1)}
                                                />
                                        }
                                    </ToggleIcon>
                                </CFFormGroup>
                                {+campaignData?.estRenvoiEnquete==1 &&
                                    <CFFormGroup>
                                        <FormLabel htmlFor="delaiBlocageRenvoiJour" >délai blocage renvoi enquête</FormLabel>
                                        <FormInput
                                            id="delaiBlocageRenvoiJour"
                                            type="number"
                                            placeHolder="Ex:5"
                                            value={campaignData?.delaiBlocageRenvoiJour || ""}
                                            onChange={e => titleChangeHandler(e)}
                                            maxLength={255}
                                            name="delaiBlocageRenvoiJour"
                                        />
                                    </CFFormGroup>  
                                }

                                {uid && userType == "ADMIN_YOUNOV" &&
                                    <CFFormGroup>
                                        <FormLabel htmlFor="title" >Identifiant campagne</FormLabel>
                                        <FormInput
                                            id="title"
                                            type="text"
                                            placeHolder="123"
                                            value={campaignData?.id || ""}
                                            

                                        />
                                    </CFFormGroup>
                                }

                            </CFFormSection>
                        </CFFormWrapper>
                    </CFSection>
         
                    <CFFormSection style={{ marginTop: "25px" }}>
                        <CFHierarchieSection>
                            <EntHeaderTitle style={{ paddingTop: "1rem" }}>
                                <span style={{ display: "flex" }}>Organisation des périmètres de gestion
                                    <IconDiv>
                                        <CTooltip title={"Ces informations représentent l’organisation de votre entreprise concernant la gestion et le découpage des périmètres de rattachement des logements (Agences, Territoires, Unités de gestion, etc…)"} className="tableActions__icon">
                                            <FontAwesomeIcon icon={faCircleInfo} style={{ marginLeft: "5px", marginRight: "2px" }} />
                                        </CTooltip>
                                      
                                    </IconDiv>
                                </span>

                            </EntHeaderTitle>
                            {ability.can('update', 'Campagne') &&
                                <PrimaryBtnOutlineAction
                                    style={{ backgroundColor: theme.colors.primary }}
                                    onClick={() => refreshHierarchieClickHandler()}
                                >
                                    <span>Rétablir l'hierarchie par défaut du bailleur &nbsp;<AutorenewIcon style={{ color: "#fff" }} /></span>
                                </PrimaryBtnOutlineAction>
                            }
                        </CFHierarchieSection>
                        <InfoHierarchie hierarchical={hierarchical} setHierarchical={setHierarchical} niveau={niveau} setNiveau={setNiveau} cannotBeModified={true} userType={userType} />
                    </CFFormSection>

                    <CFFormSection style={{ marginTop: "10px" }}>
                        <EntHeaderTitle style={{ paddingTop: "1rem" }}>
                            <span style={{ display: "flex" }}>Gestion des étapes de la campagne
                                <IconDiv>
                                    <CTooltip title={"Ces informations représentent le détail des étapes des principaux jalons de la campagne (Envoi initial, Relance, Mise en demeure)"} className="tableActions__icon">
                                        <FontAwesomeIcon icon={faCircleInfo} style={{ marginLeft: "5px", marginRight: "2px" }} />
                                    </CTooltip>

                                    
                                </IconDiv>
                            </span>

                        </EntHeaderTitle>
                        {campaignData.type == 0 ?
                            <InfoStepsCamapgneEnquete steps={steps} setSteps={setSteps} userType={userType} cannotBeModified={ability.can('update', 'Campagne') ? false : true} />
                            :
                            <InfoStepsCampagneAtestation steps={steps} setSteps={setSteps} userType={userType} cannotBeModified={ability.can('update', 'Campagne') ? false : true} />
                        }
                        </CFFormSection>

                </CFBody>
            </CFContainer>
            <CodesExternesModal
                show={confirmationModalCodeExterneShow}
                modalClosed={() => setConfirmationModalCodeExterneShow(false)}
                data={codesExternes}
                uid={uid }
                codesInternes={codesInternes }
                cancel={() => setConfirmationModalCodeExterneShow(false)}
                title={"Visualisation des codes externes"}
               
            />
        </>
    )
}


const mapStateToProps = (state) => ({
  
    userRoles: state.auth.userRoles,
    userType: state.auth.userType,
    connectedUserId: state.auth.connectedUserId,
    bailleur_id: state.auth.bailleur_id,
    hierarchicalParent: state.entities.hierarchical,
    niveauxParent: state.entities.niveaux,
    rootPath: state.entities.rootPath,

    //currentPage: state.campaigns.currentPage,
    //filtersQuery: state.campaigns.filtersQuery,
    //sortQuery: state.campaigns.sortQuery,
    //reverse: state.campaigns.reverse,
    //pageSize: state.campaigns.pageSize,


})
const mapDispatchToProps = dispatch => ({
    setHierarchieAndNiveaux: (hierarchical, niveaux, RootPath) => dispatch(actions.bailleurSetHierarchieAndNiveaux(hierarchical, niveaux, RootPath)),
    //getCampaignsPage: (page, filters, sort, reverse, pageSize, uidBailleur) => dispatch(actions.campaignsGetPage(page, filters, sort, reverse, pageSize, uidBailleur)),

})
export default connect(mapStateToProps, mapDispatchToProps)(CampaignForm)



